import { ActionButtons } from '../../../../../globalComponents/modal/ActionButtons';
import { Modal } from '../../../../../globalComponents/modal/Modal';
import { useApi } from '../../../../../hooks/useApi';
import {
	useCompanyDispatch,
	useCompanyState,
} from '../../../../../stateProviders/CompanyStateProvider';
import { LogisticCostsPermit } from '../../../../../types/api/LogisticCosts';
import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Box, SvgIcon } from '@mui/material';

interface DeletePermitModalProps {
	rowData: LogisticCostsPermit;
	gridRef: React.MutableRefObject<any>;
	modalOpen: boolean;
	setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DeletePermitModal: React.FC<DeletePermitModalProps> = ({
    rowData,
    gridRef,
    modalOpen,
    setModalOpen,
}) => {
	const api = useApi();
	const companyDispatch = useCompanyDispatch();
	const companyState = useCompanyState();

	return (
		<Modal
			open={modalOpen}
			onClose={() => setModalOpen(false)}
			modalBody={
				<Stack direction="column" alignItems="center" sx={{ textAlign: 'center' }}>
					<SvgIcon sx={{ mb: 3 }}>
						<svg width="34" height="37" viewBox="0 0 34 37" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M14.4615 5.54129H19.5385C19.5385 4.85931 19.271 4.20526 18.795 3.72302C18.3189 3.24078 17.6732 2.96987 17 2.96987C16.3268 2.96987 15.6811 3.24078 15.205 3.72302C14.729 4.20526 14.4615 4.85931 14.4615 5.54129ZM11.9231 5.54129C11.9231 4.17732 12.458 2.86922 13.4101 1.90475C14.3622 0.940273 15.6535 0.398438 17 0.398438C18.3465 0.398438 19.6378 0.940273 20.5899 1.90475C21.542 2.86922 22.0769 4.17732 22.0769 5.54129H32.2308C32.5674 5.54129 32.8902 5.67675 33.1283 5.91787C33.3663 6.15899 33.5 6.48602 33.5 6.82701C33.5 7.168 33.3663 7.49503 33.1283 7.73615C32.8902 7.97726 32.5674 8.11272 32.2308 8.11272H30.7991L27.7402 30.839C27.5328 32.3791 26.7815 33.7909 25.6254 34.8131C24.4694 35.8352 22.9869 36.3984 21.4525 36.3984H12.5475C11.0131 36.3984 9.5306 35.8352 8.37456 34.8131C7.21852 33.7909 6.46723 32.3791 6.25977 30.839L3.20092 8.11272H1.76923C1.43261 8.11272 1.10978 7.97726 0.871749 7.73615C0.633722 7.49503 0.5 7.168 0.5 6.82701C0.5 6.48602 0.633722 6.15899 0.871749 5.91787C1.10978 5.67675 1.43261 5.54129 1.76923 5.54129H11.9231ZM14.4615 14.5413C14.4615 14.2003 14.3278 13.8733 14.0898 13.6322C13.8518 13.391 13.5289 13.2556 13.1923 13.2556C12.8557 13.2556 12.5329 13.391 12.2948 13.6322C12.0568 13.8733 11.9231 14.2003 11.9231 14.5413V27.3984C11.9231 27.7394 12.0568 28.0665 12.2948 28.3076C12.5329 28.5487 12.8557 28.6842 13.1923 28.6842C13.5289 28.6842 13.8518 28.5487 14.0898 28.3076C14.3278 28.0665 14.4615 27.7394 14.4615 27.3984V14.5413ZM20.8077 13.2556C21.1443 13.2556 21.4671 13.391 21.7052 13.6322C21.9432 13.8733 22.0769 14.2003 22.0769 14.5413V27.3984C22.0769 27.7394 21.9432 28.0665 21.7052 28.3076C21.4671 28.5487 21.1443 28.6842 20.8077 28.6842C20.4711 28.6842 20.1482 28.5487 19.9102 28.3076C19.6722 28.0665 19.5385 27.7394 19.5385 27.3984V14.5413C19.5385 14.2003 19.6722 13.8733 19.9102 13.6322C20.1482 13.391 20.4711 13.2556 20.8077 13.2556ZM8.77538 30.4919C8.89996 31.4158 9.35071 32.2626 10.0442 32.8758C10.7377 33.489 11.627 33.8269 12.5475 33.827H21.4525C22.3734 33.8275 23.2633 33.4899 23.9574 32.8767C24.6514 32.2634 25.1025 31.4162 25.2272 30.4919L28.2378 8.11272H5.76223L8.77538 30.4919Z" fill="#DC3939"/>
						</svg>
					</SvgIcon>
					<Box sx={{ mb: 2 }}>
						<Typography variant="h2" fontWeight="bold">
							Are you sure you want to delete
						</Typography>
						<Typography variant="h2" fontWeight="bold">
							{rowData.permitName}?
						</Typography>
					</Box>
					<Box sx={{ width: '80%', mb: 2 }}>
						<Typography variant="sm" color="text.secondary" align="center">
							After deletion, it will no longer be available when creating quotes.
						</Typography>
					</Box>
				</Stack>
			}
			modalFooter={
				<ActionButtons
					confirmButtonText="Delete"
					confirmCallback={async () => {
						if (!companyState.logisticCosts) return;
						await api.logisticCosts.deletePermit(
							companyState.logisticCosts._id,
							rowData._id
						);
						const logisticCosts = await api.logisticCosts.find({
							_id: companyState.logisticCosts._id,
						});
						companyDispatch({ logisticCosts });
						gridRef.current?.onRefresh();
						setModalOpen(false);
					}}
					confirmButtonStyle="warning"
					cancelCallback={() => setModalOpen(false)}
				/>
			}
		/>
	);
};
